exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".panel-left .page[data-v-77391acc]{margin-top:44px;padding-bottom:44px}@media (min-width:960px){.panel.panel-left[data-v-77391acc]{border-right:1px solid #b2b2b2}}", "", {"version":3,"sources":["/./src/components/LeftPanel.vue"],"names":[],"mappings":"AACA,mCACE,gBAAiB,AACjB,mBAAqB,CACtB,AACD,yBACA,mCACI,8BAAgC,CACnC,CACA","file":"LeftPanel.vue","sourcesContent":["\n.panel-left .page[data-v-77391acc] {\n  margin-top: 44px;\n  padding-bottom: 44px;\n}\n@media (min-width: 960px) {\n.panel.panel-left[data-v-77391acc] {\n    border-right: 1px solid #b2b2b2;\n}\n}\n"],"sourceRoot":"webpack://"}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?sourceMap!./~/vue-loader/lib/style-rewriter.js?id=data-v-77391acc&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/LeftPanel.vue
// module id = 313
// module chunks = 2